// for related code and discussion, see
// https://github.com/Reactive-Extensions/rx-node/pull/16
// and
// https://github.com/HackerHappyHour/rxjs-node/blob/master/lib/fromReadStream.js
"use strict";
var Observable_1 = require("rxjs/Observable");
require("rxjs/add/operator/publish");
function fromNodeReadableStreamStatic(stream, finishEventName) {
    if (stream.pause) {
        stream.pause();
    }
    finishEventName = finishEventName || 'end';
    return Observable_1.Observable.create(function (observer) {
        function dataHandler(data) {
            observer.next(data);
        }
        function errorHandler(err) {
            observer.error(err);
        }
        function endHandler() {
            observer.complete();
        }
        stream.addListener('data', dataHandler);
        stream.addListener('error', errorHandler);
        stream.addListener(finishEventName, endHandler);
        if (stream.resume) {
            stream.resume();
        }
        return function () {
            stream.removeListener('data', dataHandler);
            stream.removeListener('error', errorHandler);
            stream.removeListener(finishEventName, endHandler);
        };
    }).publish().refCount();
}
exports.fromNodeReadableStreamStatic = fromNodeReadableStreamStatic;
;
Observable_1.Observable.fromNodeReadableStream = fromNodeReadableStreamStatic;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = fromNodeReadableStreamStatic;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnJvbU5vZGVSZWFkYWJsZVN0cmVhbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hZGQvb2JzZXJ2YWJsZS9mcm9tTm9kZVJlYWRhYmxlU3RyZWFtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLHVDQUF1QztBQUN2Qyx5REFBeUQ7QUFDekQsTUFBTTtBQUNOLGlGQUFpRjs7QUFFakYsOENBQTZDO0FBQzdDLHFDQUFtQztBQUVuQyxzQ0FBNkMsTUFBTSxFQUFFLGVBQWU7SUFDbkUsRUFBRSxDQUFDLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7UUFDbEIsTUFBTSxDQUFDLEtBQUssRUFBRSxDQUFDO0lBQ2hCLENBQUM7SUFFRCxlQUFlLEdBQUcsZUFBZSxJQUFJLEtBQUssQ0FBQztJQUUzQyxNQUFNLENBQUMsdUJBQVUsQ0FBQyxNQUFNLENBQUMsVUFBUyxRQUFRO1FBQ3pDLHFCQUFxQixJQUFJO1lBQ3hCLFFBQVEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDckIsQ0FBQztRQUVELHNCQUFzQixHQUFHO1lBQ3hCLFFBQVEsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUM7UUFDckIsQ0FBQztRQUVEO1lBQ0MsUUFBUSxDQUFDLFFBQVEsRUFBRSxDQUFDO1FBQ3JCLENBQUM7UUFFRCxNQUFNLENBQUMsV0FBVyxDQUFDLE1BQU0sRUFBRSxXQUFXLENBQUMsQ0FBQztRQUN4QyxNQUFNLENBQUMsV0FBVyxDQUFDLE9BQU8sRUFBRSxZQUFZLENBQUMsQ0FBQztRQUMxQyxNQUFNLENBQUMsV0FBVyxDQUFDLGVBQWUsRUFBRSxVQUFVLENBQUMsQ0FBQztRQUVoRCxFQUFFLENBQUMsQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQztZQUNuQixNQUFNLENBQUMsTUFBTSxFQUFFLENBQUM7UUFDakIsQ0FBQztRQUVELE1BQU0sQ0FBQztZQUNOLE1BQU0sQ0FBQyxjQUFjLENBQUMsTUFBTSxFQUFFLFdBQVcsQ0FBQyxDQUFDO1lBQzNDLE1BQU0sQ0FBQyxjQUFjLENBQUMsT0FBTyxFQUFFLFlBQVksQ0FBQyxDQUFDO1lBQzdDLE1BQU0sQ0FBQyxjQUFjLENBQUMsZUFBZSxFQUFFLFVBQVUsQ0FBQyxDQUFDO1FBQ3BELENBQUMsQ0FBQztJQUNILENBQUMsQ0FBQyxDQUFDLE9BQU8sRUFBRSxDQUFDLFFBQVEsRUFBRSxDQUFDO0FBQ3pCLENBQUM7QUFsQ0Qsb0VBa0NDO0FBQUEsQ0FBQztBQVFGLHVCQUFVLENBQUMsc0JBQXNCLEdBQUcsNEJBQTRCLENBQUM7O0FBRWpFLGtCQUFlLDRCQUE0QixDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/rx-extra/add/observable/fromNodeReadableStream.js
// module id = 416
// module chunks = 0